import { Model } from "../../../common/Interfaces";
import { IPlusPropsModel } from "./DocumentTableInterfaces";

export default function PlusModel({
  row,
  setPopupContent,
  setShowPopup,
  setPopupTitle,
}: IPlusPropsModel) {
  const handleShowPopup = (content: string[]) => {
    setPopupContent(content);
    setShowPopup(true);
  };
  return (
    <div>
      {row.models?.[0]?.code || ""}
      {row.models && row.models?.length > 1 && (
        <>
          <span
            className="plus"
            onClick={() => {
              handleShowPopup(row.models?.map((m: Model) => m.code) ?? []);
              setPopupTitle("Models");
            }}
          >
            {"+"}
            {row.models?.length - 1}
          </span>
        </>
      )}
    </div>
  );
}
